export default __webpack_public_path__ + "app/views/administration/portal/settings/settings.html";